import { RightArrowIconShort } from "../../../modules/Icons"

import FeaturebaseWidget from "../../shared/FeaturebaseWidget"

export const componentContainerClass = "flex flex-col w-full gap-6"
export const componentTextClass = "leading-[30px] text-18 text-a-light-gray"

export const bannerContainer = "w-full col-span-full bg-[#15191B] rounded-[8px] border border-gray-700"
export const contentContainer = "relative flex flex-col gap-4 z-10 px-8 py-5 justify-center lg:flex lg:items-center xl:flex-row xl:justify-between h-full"

export const textContainer = "flex flex-col items-center gap-2 lg:items-start w-full"
export const bannerHeadingTextClass = "inter text-center md:text-start text-[16px] text-gray-500"
export const bannerTextClass = "inter text-center md:text-start text-[14px] text-gray-600"

const NoTutorialsFound: React.FC<{}> = () => {

  return (
    <div cy-test-id="no-tutorials-found" className={componentContainerClass}>
      <div className={componentTextClass}><span className="font-bold text-white">No results found:</span> We couldn’t find any resources matching the selected criteria</div>

      <div className={bannerContainer}>
          <div className={contentContainer}>

            <div className={textContainer}>
              <h1 className={bannerHeadingTextClass}>
                Not finding what you're looking for?
              </h1>
              <p className={bannerTextClass}>Tell us what you need! How can we make the ActionVFX library more useful to you?</p>
            </div>

            <FeaturebaseWidget board="Academy Feedback">
              <div>
                <button
                  data-featurebase-feedback
                  className="flex items-center justify-center gap-2 transition-colors group text-14 lg:text-16 whitespace-nowrap text-a-blue hover:text-a-light-blue stroke-a-light-blue hover:stroke-a-light-blue"
                >
                  Request a Product
                  <RightArrowIconShort className="inline stroke-inherit w-[20px] h-[20px] group-hover:translate-x-1 transition-transform duration-200 ease-in-out" />
                </button>
              </div>
            </FeaturebaseWidget>
          </div>
      </div>
    </div>
  )
}

export default NoTutorialsFound